import {useQuery} from "@tanstack/react-query";
import {DataTable, useDataTableStorage, useSpringPage, useSpringPageable} from "@variocube/app-ui";
import React, {useMemo} from "react";
import {useCompartmentApi} from "../../api";
import {EmptyList} from "../../controls";
import {useLocalization, useWordingFlavor} from "@smalox/shared";
import {useTenantId} from "../../tenant";
import {queryKeys} from "../../utils/queryKeys";
import {useNumericParam} from "../../utils/useParam";
import {BookingCell} from "../booking/BookingCell";
import {BookingFromCell} from "../booking/BookingFromCell";
import {BookingRetrievalConfirmation} from "../booking/BookingRetrievalConfirmation";
import {BookingUntilCell} from "../booking/BookingUntilCell";
import {BookingUsersCell} from "../booking/BookingUsersCell";

export function CompartmentBookingList() {
	return (
		<BookingRetrievalConfirmation>
			<CompartmentBookingListConfirmed />
		</BookingRetrievalConfirmation>
	);
}

export function CompartmentBookingListConfirmed() {
	const {t} = useLocalization();
	const wordingFlavor = useWordingFlavor();
	const tenantId = useTenantId();
	const compartmentId = useNumericParam("compartmentId");

	const {getCompartmentBookings} = useCompartmentApi();

	const columns = useMemo(() => [
		{
			label: t(`bookings.single.${wordingFlavor}`),
			field: "id",
			sortable: true,
			default: true,
			component: BookingCell,
		},
		{
			label: t("bookings.from"),
			field: "from",
			sortable: true,
			default: true,
			component: BookingFromCell,
		},
		{
			label: t("bookings.until"),
			field: "until",
			sortable: true,
			default: true,
			component: BookingUntilCell,
		},
		{
			label: t("bookings.users.title"),
			field: "user.username",
			sortable: true,
			default: true,
			component: BookingUsersCell,
		},
	], [t, wordingFlavor]);

	const {onPageChange, onSort, ...storage} = useDataTableStorage("CompartmentBookingList.paging");
	const pageable = useSpringPageable(storage);

	const {isLoading, error, data} = useQuery(
		queryKeys.compartmentBookings(tenantId, compartmentId, pageable),
		() => getCompartmentBookings(compartmentId, pageable),
	);
	const {rows, page} = useSpringPage(data);

	return (
		<DataTable
			columns={columns}
			rows={rows}
			page={page}
			loading={isLoading}
			error={error}
			onSort={onSort}
			onPageChange={onPageChange}
			empty={<EmptyList />}
			{...storage}
		/>
	);
}
